export default __webpack_public_path__ + "media/zurb/img/events/speaking/speaking-thumb-6a2d1db45230c98c476b6743bed281dd.png";